// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"984":"d7526c","3358":"ad8cac"}[chunkId] + ".css";
};